@if (!active()) {
    <a
        [routerLink]="url()"
        [sfHtmlAttributes]="attribs() ?? {}"
        [target]="attribs()?.['target']"
        [queryParams]="linkProps()?.queryParams ?? null"
        [fragment]="linkProps()?.fragment"
        [queryParamsHandling]="linkProps()?.queryParamsHandling ?? null"
        [preserveFragment]="linkProps()?.preserveFragment ?? false"
        [skipLocationChange]="linkProps()?.skipLocationChange ?? false"
        [replaceUrl]="linkProps()?.replaceUrl ?? false"
        [state]="linkProps()?.state ?? {}">
        <ng-container *ngTemplateOutlet="defaultBreadcrumbItemContentTemplate" />
    </a>
} @else {
    <span [sfHtmlAttributes]="attribs() ?? {}">
        <ng-container *ngTemplateOutlet="defaultBreadcrumbItemContentTemplate" />
    </span>
}

<ng-template #defaultBreadcrumbItemContentTemplate>
    <ng-content />
</ng-template>
